import { render, staticRenderFns } from "./ConsultaDeComprasDiretas.vue?vue&type=template&id=417f2d2b"
import script from "./ConsultaDeComprasDiretas.vue?vue&type=script&lang=js"
export * from "./ConsultaDeComprasDiretas.vue?vue&type=script&lang=js"
import style0 from "./ConsultaDeComprasDiretas.vue?vue&type=style&index=0&id=417f2d2b&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports